/**
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
const InRange = {
  rev: {
    0: 'Normal',
    1: 'Underload',
    2: 'Overload',
  },

  Normal: 0,
  Underload: 1,
  Overload: 2,
};

export default InRange;
